import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import MLHostCreate from "./MLHostCreate";


class MLHostList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mlhosts: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveMLHosts();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveMLHosts();
        }
    }

    async retrieveMLHosts() {
        const url = 'mlhost/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                mlhosts: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.mlhosts) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'ML Серверы'}
                    url={'mlhost'}
                    data={this.state.mlhosts}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: MLHostCreate,
                            componentProps: {}
                        }
                    ]}
                    callBack={this.retrieveMLHosts.bind(this)}
                    fields={[
                        {
                            title: 'Полное название',
                            name: 'title',
                            linkPattern: '/mlhost/detail/:linkParam',
                            linkParam: 'id',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(MLHostList)
